<div class="color-chooser">
  {{ 'i18n.control.colorChooser.color' | translate }}:
  <div class="control" #root>
    <div (click)="showPalette = true; adaptPaletteHeight()">
      <div id="current-color"
           [style.backgroundColor]="currentColor"
      ></div>
    </div>
    <div id="palette"
         [ngClass]="{'hidden': !showPalette}"
         [style.height]="paletteHeight"
         [style.width]="paletteWidth"
         [style.left]="paletteLeft"
    >
      <div #wrapper class="colors-wrapper" [style.max-height]="paletteHeight">
        <div class="additional-colors colors"
             *ngIf="colors.additionalColors.length > 0">
          <div class="color"
               [ngClass]="{'active': color == currentColor}"
               *ngFor="let color of colors.additionalColors"
               [style.backgroundColor]="color"
               (click)="setColor(color)"
          >
          </div>
          <div class="phantom color"
               *ngFor="let p of phantoms.additionalColors"></div>
        </div>
        <div class="base-colors colors">
          <div class="color"
               [ngClass]="{'active': color == currentColor}"
               *ngFor="let color of colors.baseColors"
               [style.backgroundColor]="color"
               (click)="setColor(color)"
          >
          </div>
          <div class="phantom color"
               *ngFor="let p of phantoms.baseColors"></div>
        </div>
      </div>

      <div class="arrow" [style.left]="arrowLeft">
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/color-chooser/color-chooser.component.html